"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownEnum = void 0;
var DropDownEnum;
(function (DropDownEnum) {
    DropDownEnum["Select"] = "Select Option";
})(DropDownEnum = exports.DropDownEnum || (exports.DropDownEnum = {}));
//# sourceMappingURL=DropDownEnum.js.map